import React from 'react'

function DomainSelection() {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-lg-12">
                    <div className="contact-form-area " style={{ height: '100vh'}}>
                        <div className="containerrr">
                            <div className="row justify-content-center" style={{ height: '100vh'}}>
                                <div className="col-xl-4 col-lg-12 bg-livebts pb-0 pt-5 mt-5 justify-content-center d-flex">
                                    <div className="content p-3 pb-0 w-75">
                                        <div className="col-xl-12 col-sm-12">
                                            <div className="single-pricing style-two text-center single-pricing-active p-4">
                                                <h6 className="title mb-2">GOLDEN</h6>
                                                <div className="thumb mb-2 p-0">
                                                    <img src="{{ asset('front/assets/img/price/6.svg') }}" alt="pricing"/>
                                                </div>
                                                <div className="amount mb-0 pb-0">
                                                    <h3 className="price">Rs. 7,000 <span>/Year</span></h3>
                                                    <del>Rs. 14,000</del>
                                                    <p>Save 50% on 1st Year</p>
                                                </div>
                                                <ul className="pb-0">
                                                    <li>1 Free Domain <br />
                                                        (.com | .net | .org | .info)</li>
                                                    <li>4 GB Housing Space</li>
                                                </ul>
                                                <a className="btn btn-white btn-rounded" href="#">Get Started</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 bg-dark p-0">
                                    <div className="content-2 h-100">
                                        <div className="container d-flex flex-column justify-content-between h-100">
                                            <div>
                                                <img src="{{ asset('front/assets/img/lb-logo-alt.svg') }}" width="150px"
                                                    alt="" className="pt-3 pb-5" />
                                                    <div className="row custom-gutters-28">
                                                        <div className="col-xl-6 col-lg-4 col-sm-6">
                                                            <div className="single-offer">
                                                                <div className="media flex-column align-items-center ">
                                                                    <img src="{{ asset('front/assets/img/startup/offer/1.svg') }}"
                                                                        alt="offer" />
                                                                        <div className="media-body align-self-center">
                                                                            <h6>New Domain</h6>
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-6 col-lg-4 col-sm-6">
                                                            <div className="single-offer">
                                                                <div className="media flex-column align-items-center">
                                                                    <img src="{{ asset('front/assets/img/startup/offer/2.svg') }}"
                                                                        alt="offer" />
                                                                        <div className="media-body align-self-center">
                                                                            <h6>Existing Domain</h6>
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                            <div>
                                                <div className="row">
                                                    <div className="col-xl-12 col-lg-12 col-12">
                                                        <div className="header-inner-details pb-5">
                                                            <div className="header-inner">
                                                                <form className="sbh-main-search d-flex">
                                                                    <div className="search-input float-left">
                                                                        <input type="text" id="domain" name="domain"
                                                                            placeholder="Enter domain name" />
                                                                    </div>
                                                                    <select id="btn-check">
                                                                        <option value="option1">Option 1</option>
                                                                        <option value="option2">Option 2</option>
                                                                        <option value="option3">Option 3</option>
                                                                    </select>
                                                                    <button type="button" id="check-btn"
                                                                        onclick="checkDomain()">Check Availability</button>
                                                                </form>
                                                                <div id="result" className="result p-4 pb-0 d-flex justify-content-end">
                                                                   <a a type="button" href="#" id="check-btn">Proceed <i className="la la-arrow-right"></i> </a> 
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>
  )
}

export default DomainSelection